export const getDigFromString = (item: number | string) => {
  if (typeof item === 'number') {
    return item
  }

  const answer = parseInt(item?.replace(/[^\d]/g, ''));
  if (!item?.trim() || isNaN(answer)) {
    return 0;
  }

  return parseInt(item.replace(/[^\d]/g, ''))
}

export const getRandomIntInclusive = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}